import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { MarkdownContent } from 'src/components/markdown-content'
import { getReportingGuide } from 'src/content/help'

export const ReportingGuidePage = () => {
  const { i18n } = useTranslation()
  const { hash } = useLocation()

  // Scroll to the in-page anchor on load and whenever it changes.
  useEffect(() => {
    if (!hash) return
    document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView()
  }, [hash, i18n.language])

  return (
    <div className="mx-auto max-w-3xl px-6 py-10" data-testid="reporting-guide">
      <MarkdownContent>{getReportingGuide(i18n.language)}</MarkdownContent>
    </div>
  )
}
